import { createRoot } from "react-dom/client";
import { AppBootstrapper, IAppMode, IAuthType } from "./bootstrapper";
import { IRouterType } from "./routes/router";
import WebComponentInit from "./web-component-init";

const owner = document.getElementById("emre-inanc-01-fason-surec-takip");
if (owner) {
  const container = document.getElementById("emre-inanc-01-fason-surec-takip");

  const root = createRoot(container!);

  const authType: IAuthType = "Kuika";
  const routerType: IRouterType = "BrowserRouter";
  const appMode: IAppMode = "WebSite";

  root.render(
    <AppBootstrapper authType={authType} routerType={routerType} appMode={appMode} />,
    document.getElementById("emre-inanc-01-fason-surec-takip")
  );

  if ((module as any).hot) {
    (module as any).hot.accept();
  }
} else {
  WebComponentInit();
}

const workspace = "emre_inanc_01";
const app = "fasonSurecTakip";
const webComponentTag = "emre-inanc-01-fason-surec-takip";
export { app, webComponentTag, workspace };
